import styles from '../../../sass/components/buttons/button.module.scss'
import {Fragment} from "react";

export function Button({
                           className = null,
                           dataQa,
                           dataTestid,
                           size = 'md',
                           iconLeft = null,
                           iconRight = null,
                           iconType = 'fas',
                           onClick = null,
                           disabled = false,
                           type = 'button',
                           href = null,
                           children
                       }) {

    function defaultOnClick() {
    }

    return (
        <Fragment>
            {type === 'a' && (
                <a
                    className={`${styles.button} ${styles[size]} ${className}`}
                    href={href ?? '#'}
                    onClick={onClick ?? defaultOnClick}
                >
                    {iconLeft && (
                        <i className={`${styles.iconLeft} ${iconType} ${iconLeft}`}></i>
                    )}
                    <span>{children}</span>
                    {iconRight && (
                        <i className={`${styles.iconRight} ${iconType} ${iconRight}`}></i>
                    )}
                </a>
            )}
            {type !== 'a' && (
                <button
                    type={type}
                    /* TODO: This data-qa should be deleted after migrating all pages */
                    data-qa={dataQa}
                    data-testid={dataTestid}
                    className={`${styles.button} ${styles[size]} ${className}`}
                    onClick={onClick ?? defaultOnClick}
                    disabled={disabled}
                >
                    {iconLeft && (
                        <i className={`${styles.iconLeft} ${iconType} ${iconLeft}`}></i>
                    )}
                    <span>{children}</span>
                    {iconRight && (
                        <i className={`${styles.iconRight} ${iconType} ${iconRight}`}></i>
                    )}
                </button>)}
        </Fragment>
    )
}
